/**
 * Utilitaires pour formater les données de performance
 */

/**
 * Convertit les millisecondes en format lisible (ms ou s)
 */
export function formatTimeFromMs(ms: number | null | undefined): string {
  if (!ms || ms === 0) return '0s';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

/**
 * Convertit un score décimal (0-1) en pourcentage (0-100)
 */
export function convertScoreToPercentage(score: number | null | undefined): number {
  if (!score) return 0;
  return Math.round(score * 100);
}

/**
 * Détermine le grade basé sur le score
 */
export function getGradeFromScore(score: number): string {
  if (score >= 90) return 'A';
  if (score >= 70) return 'B';
  if (score >= 50) return 'C';
  return 'D';
}

/**
 * Détermine la couleur CSS basée sur le score
 */
export function getColorFromScore(score: number): string {
  if (score >= 90) return 'from-green-500 to-emerald-500';
  if (score >= 70) return 'from-blue-500 to-indigo-500';
  if (score >= 50) return 'from-orange-500 to-yellow-500';
  return 'from-red-500 to-pink-500';
}

/**
 * Formate une date en format français
 */
export function formatDateToFrench(dateString: string | null | undefined): string {
  if (!dateString) return new Date().toLocaleDateString('fr-FR');
  
  try {
    return new Date(dateString).toLocaleDateString('fr-FR');
  } catch {
    return new Date().toLocaleDateString('fr-FR');
  }
}

/**
 * Calcule le niveau de priorité d'un problème
 */
export function getPriorityLevel(criticalIssues: number, warnings: number): 'high' | 'medium' | 'low' {
  if (criticalIssues > 0) return 'high';
  if (warnings > 3) return 'medium';
  return 'low';
}

/**
 * Génère un message de statut basé sur les métriques
 */
export function getPerformanceStatus(performanceScore: number, seoScore: number): {
  status: 'excellent' | 'good' | 'needs-improvement' | 'poor';
  message: string;
} {
  const averageScore = (performanceScore + seoScore) / 2;
  
  if (averageScore >= 90) {
    return {
      status: 'excellent',
      message: 'Excellent ! Votre site performe très bien.'
    };
  }
  
  if (averageScore >= 70) {
    return {
      status: 'good',
      message: 'Bon travail ! Quelques améliorations possibles.'
    };
  }
  
  if (averageScore >= 50) {
    return {
      status: 'needs-improvement',
      message: 'Des améliorations sont nécessaires pour optimiser votre site.'
    };
  }
  
  return {
    status: 'poor',
    message: 'Attention ! Votre site nécessite des améliorations urgentes.'
  };
}
